import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Eye } from "react-feather";
import { useSelector } from "react-redux";
import Table from "../../../core/pagination/datatable";
import TooltipIcons from "../../common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../common/tooltip-content/refresh";
import CollapesIcon from "../../common/tooltip-content/collapes";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import SettingsSideBar from '../../../feature-module/settings/settingssidebar';
import Select from "react-select";
import CommonFooter from "../../common/footer/commonFooter";

const StoreList = () => {
  //const { id } = useParams();
  const data = useSelector((state) => state.rootReducer.shopdata);
  const TypeOptions = [
    { value: "PointOfSale", label: "Point de vente" },
    { value: "Lab", label: "Laboratoire" },
    { value: "Warehouse", label: "Dépots" },
    { value: "Adminstration", label: "Administration" },
  ];
  const [selectedTypeEdit, setSelectedTypeEdit] = useState([TypeOptions[0], TypeOptions[1]]);
  const [code, setCode] = useState('BR55');
  const [name, setName] = useState('Taïeb');
  const [dateOuverture, setDateOuverture] = useState('2024-02-15');
  const [adresse, setAdresse] = useState('23, Av de la Liberté');
  const [ville, setVille] = useState('Tunis');
  const [cp, setCp] = useState('1002');
  const [pays, setPays] = useState('Tunisie');
  const [email, setEmail] = useState('belvedere@galetis.com');
  const [tel, setTel] = useState('+216 71 123 123');
  const [desc, setDesc] = useState('Boutique historique située au centre ville');
  const [statut, setStatut] = useState(true);
  const [selectedType, setSelectedType] = useState();
  const handleSubmit = (e) => {
    e.preventDefault();
    // Traite la mise à jour des données dans ta logique (API, etc)
    // Exemple : submit au backend
    // puis éventuellement navigate("/stores");
  };
  const columns = [
    {
      title: "Entité",
      dataIndex: "NameCode",
      sorter: (a, b) => a.NameCode.length - b.NameCode.length,
    },

    {
      title: "Ouverture",
      dataIndex: "Ouverture",
      sorter: (a, b) => a.Ouverture.length - b.Ouverture.length,
    },

    {
      title: "Téléphone",
      dataIndex: "Phone",
      sorter: (a, b) => a.Phone.length - b.Phone.length,
    },

    {
      title: "Adresse",
      dataIndex: "Adresse",
      sorter: (a, b) => a.Adresse.length - b.Adresse.length,
    },
    {
      title: "Statut",
      dataIndex: "Code",
      render: () => (
        <span className={`badge  badge-success d-inline-flex align-items-center badge-xs`}>
          <i className="ti ti-point-filled me-1" />
          Active
        </span>

      ),
      sorter: (a, b) => a.Code.length - b.Code.length,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

            <Link className="me-2 p-2" to="#">
              <Eye className="feather-view" />
            </Link>

            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit-store"
            >
              <Edit className="feather-edit" />
            </Link>

            <Link
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              className="p-2 d-flex align-items-center border rounded"
              to="#"
            >
              <i data-feather="trash-2" className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];


  return (
    <>
      <div className="page-wrapper">
        <div className="content">

          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4 className="fw-bold">Dépots & Labos</h4>
                <h6>Gérez vos dépots et laboratoires</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link to="#" data-bs-toggle="modal" data-bs-target="#add-store" className="btn btn-primary">
                <PlusCircle data-feather="plus-circle" className=" me-2" />
                Ajouter une entité
              </Link>
            </div>
          </div>

          {/* /product list */}
          <div className="row">
            <div className="col-xl-12">
              <div className="settings-wrapper d-flex">
                <SettingsSideBar />
                <div className="card table-list-card">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <div className="search-set">

                    </div>
                    <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">

                      <div className="dropdown me-2">
                        <Link
                          to="#"
                          className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                          data-bs-toggle="dropdown"
                        >
                          Select Statut
                        </Link>
                        <ul className="dropdown-menu  dropdown-menu-end p-3">
                          <li>
                            <Link to="#" className="dropdown-item rounded-1">
                              Active
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="dropdown-item rounded-1">
                              Inactive
                            </Link>
                          </li>

                        </ul>
                      </div>

                    </div>
                  </div>
                  <div className="card-body pb-0">
                    <div className=" table-responsive">
                      <Table columns={columns} dataSource={data} />
                    </div>
                  </div>
                </div>
              </div></div></div>
          {/* /product list */}

        </div>
         <CommonFooter/>

      </div>
      <>
        {/* Add Store */}
        <div className="modal fade" id="add-store">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="page-title">
                  <h4>Ajouter entité</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form >
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="mb-3">
                        <label className="form-label">
                          Code  <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div className="mb-8">
                        <label className="form-label">
                          Nom de l&apos;entité <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-8 pe-0">
                      <div className="mb-3">
                        <label className="form-label">Type entité <span className="text-danger">*</span></label>
                        <Select
                          isMulti
                          options={TypeOptions}
                          value={selectedType}
                          onChange={setSelectedType}
                          placeholder="Sélectionnez le type…"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Date d&apos;ouverture <span className="text-danger">*</span></label>
                      <input
                        type="date"
                        className="form-control"

                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Adresse <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>

                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Ville  <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-8">
                        <label className="form-label">
                          Code postale <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-8">
                        <label className="form-label">
                          Pays <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-7">
                      <div className="mb-3">
                        <label className="form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input type="email" className="form-control" />
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="mb-3">
                        <label className="form-label">
                          Téléphone <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="mb-3 input-blocks">
                      <label className="form-label">Description</label>
                      <textarea
                        className="form-control mb-1"
                        defaultValue={""}
                      />
                      <p>Maximum 200 caractères</p>
                    </div>
                  </div>
                  <div className="mb-0">
                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                      <span className="status-label ">Statut</span>
                      <input
                        type="checkbox"
                        id="user2"
                        className="check"
                        defaultChecked
                      />
                      <label htmlFor="user2" className="checktoggle" />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  {/* <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                    Annuler
                  </button> */}
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                  ><i className="ti ti-circle-plus me-1"></i>

                    Ajouter
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add Store */}
        {/* Edit Store */}
        <div className="modal fade" id="edit-store">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="page-title">
                  <h4>Modifier l&apos;entité</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="container py-4">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="mb-3">
                        <label className="form-label">
                          Code <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={code}
                          onChange={e => setCode(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div className="mb-3">
                        <label className="form-label">
                          Nom de la boutique <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={name}
                          onChange={e => setName(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-8 pe-0">
                      <div className="mb-3">
                        <label className="form-label">
                          Type entité <span className="text-danger">*</span>
                        </label>
                        <Select
                          isMulti
                          options={TypeOptions}
                          value={selectedTypeEdit}
                          onChange={setSelectedTypeEdit}
                          placeholder="Sélectionnez le type…"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">
                        Date d&apos;ouverture <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={dateOuverture}
                        onChange={e => setDateOuverture(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Adresse <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={adresse}
                      onChange={e => setAdresse(e.target.value)}
                    />
                  </div>

                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Ville <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={ville}
                          onChange={e => setVille(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Code postale <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={cp}
                          onChange={e => setCp(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label className="form-label">
                          Pays <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={pays}
                          onChange={e => setPays(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-7">
                      <div className="mb-3">
                        <label className="form-label">
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="mb-3">
                        <label className="form-label">
                          Téléphone <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={tel}
                          onChange={e => setTel(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="mb-3 input-blocks">
                      <label className="form-label">Description</label>
                      <textarea
                        className="form-control mb-1"
                        value={desc}
                        onChange={e => setDesc(e.target.value)}
                        maxLength={200}
                      />
                      <p>Maximum 200 caractères</p>
                    </div>
                  </div>

                  <div className="mb-0">
                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                      <span className="status-label ">Statut</span>
                      <input
                        type="checkbox"
                        id="user2"
                        className="check"
                        checked={statut}
                        onChange={() => setStatut(!statut)}
                      />
                      <label htmlFor="user2" className="checktoggle" style={{ marginBottom: 0 }} />
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                      data-bs-dismiss="modal"
                    >
                      Annuler
                    </button>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary fs-13 fw-medium p-2 px-3"
                    >
                      Enregistrer
                    </button>
                  </div>
                </form>
              </div>


            </div></div></div>

        {/* /Edit Store */}
      </>

      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content p-5 px-3 text-center">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                  Supprimer l&apos;entité
                </h4>
                <p className="text-gray-6 mb-0 fs-16">
                  Êtes-vous sûre de supprimer cet entité?
                </p>
                <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="btn btn-submit fs-13 fw-medium p-2 px-3"
                  >
                    Oui, supprimer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>

  );
};

export default StoreList;
